<div class="dialog-wrapper">
  <app-modal-header-common
    [title]="'Finance Comparator'"
    [dialogRef]="dialogRef"
  ></app-modal-header-common>

  <div class="px-3 py-3">
    <ul>
      <li
        *ngFor="
          let breadcrumb of breadCrumbData;
          first as isFirst;
          last as isLast
        "
      >
        <span *ngIf="!isLast" class="color-history-inactive">{{
          breadcrumb
        }}</span>
        <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
      </li>
    </ul>
  </div>
  <div class="dialog-content">
    <app-finance-comparitor
      [portfolioId]="data?.portfolioId"
      [subportfolioId]="data?.subportfolioId"
      [programId]="data?.programId"
      [projectId]="data?.projectId"
      [vendorId]="data?.vendorId"
    ></app-finance-comparitor>
  </div>
  <div class="modal-footer">
    <button mat-button color="primary" (click)="close()">Close</button>
  </div>
</div>
